import { apiRequest } from "./api";

// Public endpoints (no auth) since the wizard itself isn't login-gated.

// GET /lookups/preparer-credentials -> [{ code, label }, ...]
export async function getPreparerCredentials() {
  return apiRequest("/lookups/preparer-credentials");
}

// GET /lookups/states -> [{ code, name }, ...]
export async function getUsStates() {
  return apiRequest("/lookups/states");
}

// GET /countries -> [{ id, name, isoCode }, ...]
export async function getCountries() {
  return apiRequest("/countries");
}

// GET /lookups/business-types -> [{ code, label }, ...]
export async function getBusinessTypes() {
  return apiRequest("/lookups/business-types");
}

// GET /lookups/weight-categories[?firstUsedMonth=YYYY-MM] ->
// [{ code, weightLabel, annualNormalAmt, annualLoggingAmt, periodNormalAmt, periodLoggingAmt }, ...]
// periodNormalAmt/periodLoggingAmt are the partial_period_rate table's figure for
// firstUsedMonth (or the same as the annual* fields for July/omitted/invalid months).
export async function getWeightCategories(firstUsedMonth) {
  const qs = firstUsedMonth ? `?firstUsedMonth=${encodeURIComponent(firstUsedMonth)}` : "";
  return apiRequest(`/lookups/weight-categories${qs}`);
}

// GET /lookups/months -> [{ value, label, monthsRemaining }, ...]
export async function getFirstUsedMonths() {
  return apiRequest("/lookups/months");
}

// GET /lookups/tax-years -> [{ code, label, sub }, ...]
export async function getTaxYears() {
  return apiRequest("/lookups/tax-years");
}

// GET /lookups/form-types -> [{ code, title, sub }, ...]
export async function getFormTypes() {
  return apiRequest("/lookups/form-types");
}

// GET /lookups/amend-reasons -> [{ code, title, sub }, ...]
export async function getAmendReasons() {
  return apiRequest("/lookups/amend-reasons");
}

// GET /lookups/service-fee-rates -> [{ filingType, minVehicles, maxVehicles, feeAmount }, ...]
// The live e-filing service fee schedule (service_fee_rate table) - for the
// public Pricing page. minVehicles/maxVehicles both null = a flat fee not
// tied to vehicle count (filingType "amended"); maxVehicles null alone = an
// open-ended top band (e.g. 501+).
export async function getServiceFeeRates() {
  return apiRequest("/lookups/service-fee-rates", { auth: false });
}

// GET /lookups/prior-year-options -> [{ code, title, subtitle }, ...]
export async function getPriorYearOptions() {
  return apiRequest("/lookups/prior-year-options");
}

// GET /lookups/credit-reasons -> [{ code, label }, ...]
export async function getCreditReasons() {
  return apiRequest("/lookups/credit-reasons");
}

// GET /lookups/payment-methods -> [{ code, title, sub }, ...]
export async function getPaymentMethods() {
  return apiRequest("/lookups/payment-methods");
}

// GET /lookups/credit-amount?category=&logging=&creditDate= -> { creditAmt }
// Server-computed Line-5 credit for a vehicle disposed of on a PRIOR return -
// creditDate is read against the prior filing period (July 2025-June 2026),
// NOT the current return's own first-used month/period, from the
// partial_period_rate table at the month after the disposal month.
export async function getCreditAmount({ category, logging, creditDate }) {
  const qs = new URLSearchParams({ category, logging: String(!!logging), creditDate });
  const data = await apiRequest(`/lookups/credit-amount?${qs.toString()}`);
  return Number(data?.creditAmt);
}
